<div class="registration-overlay">
  <div class="registration-card">

    <div class="header">
      @if (authService.isLoggedIn()) {
      <span class="username">{{authService.getDisplayName()}}</span>
      <svg class="circle-user" lucideLogOut (click)="authService.logout()"></svg>
      }

    </div>

    <header class="card-header">
      <div class="logo-container">
        <img class="aguai-logo" src="images/aguai-logo.png" alt="Aguaí FC Logo">
      </div>
      <h2 class="competition-title">Peneira Aguaí 2026</h2>
      <p class="competition-age-groups">Sub-15, sub-17 e sub-20</p>
      <p class="subtitle">Sua chance de jogar no mais disputado campeonato de base do Brasil – o Paulistão - com a
        camisa do Aguaí. Quanto maior o seu ranking, maior sua chance de ser selecionado. Registre-se agora, faça os
        oito exercícios e participe!</p>
    </header>

    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="registration-form">

      <div class="glass-card">
        <p class="card-content">
          <span class="highlight">Data de início:</span> 06/04/2026<br />
          <span class="highlight">Fechamento do ranking:</span> 05/06/2026<br />
          <span class="highlight">Data da avaliação:</span> 14/06/2026<br />
          <br />
          Avaliação somente para atletas homens nascidos entre 2012 e 2006
        </p>
      </div>

      <p class="section-label">PERFIL DO JOGADOR</p>

      <div class="input-group">
        <input formControlName="firstName" placeholder="Nome">
      </div>

      <div class="input-group">
        <input formControlName="lastName" placeholder="Sobrenome">
      </div>

      <div class="input-group phone-group">
        <select formControlName="countryCode" class="country-select">
          <option *ngFor="let c of countries" [value]="c.code">{{c.flag}} {{c.code}}</option>
        </select>
        <input formControlName="phoneNumber" placeholder="Número do Whatsapp">
      </div>

      <div class="input-group">
        <input formControlName="city" placeholder="Cidade">
      </div>

      <div class="input-group">
        <select formControlName="position" class="full-select">
          <option value="" disabled selected>Posição principal</option>
          <option *ngFor="let p of positions" [value]="p">{{p}}</option>
        </select>
      </div>

      <div class="input-group">
        <input formControlName="club" placeholder="Clube de Futebol">
      </div>

      <div class="terms-container">
        <input type="checkbox" formControlName="agreedToTerms" id="terms" [checked]="isAccepted()"
          (change)="isAccepted.set($any($event.target).checked)">
        <label for="terms">
          Concordo com os <a class="highlight-link" (click)="sheet.open()">Termos e Condições</a>
        </label>
        <app-terms-sheet #sheet (onStatusChange)="updateTerms($event)"></app-terms-sheet>
      </div>

      <button type="submit" class="submit-btn" [disabled]="registrationForm.invalid"
        [class.btn-valid]="registrationForm.valid">
        Enviar
      </button>
    </form>

    <footer class="footer-container">
      <div class="divider"></div>

      <img src="https://peneiras.cuju.pro/hubfs/6644755c6baad5643810f8e8_Vectors-Wrapper.svg" alt="CUJU Logo"
        class="footer-logo" />

      <p class="footer-description">©2026 CUJU. Todos os direitos reservados.</p>

      <button type="button" class="accent-link" (click)="sheet.open()">Termos e Condições</button>

      <nav class="legal-links">
        <a href="https://services.cuju.pro/content-service/privacy/pt-BR" target="_blank" rel="noopener noreferrer"
          class="accent-link">
          Política de Privacidade
        </a>
        <a href="https://cuju.pro/imprint" target="_blank" rel="noopener noreferrer" class="accent-link">
          Imprint
        </a>
      </nav>

      <div class="contact-section">
        <p class="contact-label">Fale conosco:</p>
        <a href="mailto:hello@cuju.pro" class="contact-email">hello&#64;cuju.pro</a>
        <div class="address-info">
          <p>ROGON Technologies GmbH</p>
          <p>Mahlast. 21</p>
          <p>67227</p>
          <p>Frankenthal (Germany)</p>
        </div>
      </div>
    </footer>
  </div>
</div>